/**
 * Legacy URL: /semaglutide-versus-weight-loss-surgery-outcomes/sleeve.
 * Permanent redirect to the sleeve gastrectomy page (/services/sleeve).
 * Intentionally excluded from the sitemap (redirect target only).
 */
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/semaglutide-versus-weight-loss-surgery-outcomes/sleeve")({
  beforeLoad: () => {
    throw redirect({ to: "/services/sleeve", statusCode: 301, replace: true });
  },
});
